import { AAMVAInfo } from "common";
import { SexOffender } from 'st-app/api'

export const formatName = (aamva: AAMVAInfo | undefined) => {
    if (!aamva) return '';

    return [
        aamva.firstName,
        aamva.middleName?.split(',').join(' '),
        aamva.lastName
    ].filter(Boolean).join(' ');
}

export const formatAddress = (info: AAMVAInfo | SexOffender | undefined) => {
    if (!info) return '';

    if ('zip' in info) {
        const zip5 = info.zip?.slice(0, 5) || '';
        const zipExtra = info.zip?.slice(5) || '';
        const zip = zipExtra ? `${zip5}-${zipExtra}` : zip5;
        return (
            <>
                <span>{`${info.street1||''} ${info.street2 ||''}`.trim()}</span>
                <br />
                <span>{`${info.city||''}, ${info.state ||''} ${zip}`}</span>
            </>
        )
    } else if ('address' in info) {
        return (
            <>
                <span>{info.address}</span>
                <br />
                <span>{info.city || ''}, {info.state || ''} {info.zipcode || ''}</span>
            </>
        );
    }
}

export const formatDob = (dob: string | undefined) => {
    if (!dob) return '';

    if (dob.includes('Z') || dob.includes('T')) {
        return new Date(dob).toLocaleDateString();
    } else if (/^\d{4}-\d{1,2}-\d{1,2}/.test(dob)) {
        const [year, month, day] = dob.substring(0, 10).split('-');
        return `${month}/${day}/${year}`;
    } else if (dob.includes('/')) {
        // Already a slash-formatted date (e.g. "09/18/1987") � leave as-is.
        return dob;
    } else {
        const month = dob.substring(0, 2);
        const day = dob.substring(2, 4);
        const year = dob.substring(4, 8);
        return `${month}/${day}/${year}`;
    }
}

export const formatHeight = (height: number | string | undefined) => {
    if (height === undefined || height === null || height === '') return '';

    const inches = typeof height === 'number' ? height : parseInt(height as string, 10);
    if (isNaN(inches)) return String(height);

    const feet = Math.floor(inches / 12);
    const remainingInches = inches % 12;
    return `${feet}'${remainingInches}"`;
}

export const formatGender = (g: string | undefined) => {
    const v = g?.trim().toLowerCase() || '';
    if (v === '1' || v === 'm' || v === 'male') return 'M';
    if (v === '0' || v === 'f' || v === 'female') return 'F';
    return g?.trim() || '';
}
